import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { ShippingMethodCode } from '@web/shared/module/shop';
import { AdminShippingMethodContextOperationsResponse } from './admin-shipping-method-context-operations.response';
import { AdminShippingMethodPriceResponse } from './admin-shipping-method-price.response';

@jsonObject
export class AdminShippingMethodDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly category!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminShippingMethodContextOperationsResponse)
  public readonly contextOperations!: AdminShippingMethodContextOperationsResponse;

  @jsonArrayMember(AdminShippingMethodPriceResponse)
  public readonly prices!: AdminShippingMethodPriceResponse[];
}
